import Hero from './components/Hero';
import About from './components/About';
import Experiences from './components/Experiences';
import Gallery from './components/Gallery';
import Booking from './components/Booking';
import Testimonials from './components/Testimonials';
import Footer from './components/Footer';
import Navigation from './components/Navigation';

export default function Home() {
  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      <Hero />
      <About />
      <Experiences />
      <Gallery />
      <Testimonials />
      <Booking />
      <Footer />
    </div>
  );
}
